import { Box, ButtonBase, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LEVEL_TONE } from '../utils/constants';
import { fmtHours } from '../utils/hours';
import PersonAvatar from './PersonAvatar';
import LoadBar from './LoadBar';
import LoadPercent from './LoadPercent';
import LoadTag from './LoadTag';

/** One person as a stacked card - the table's row below `md`, where six columns of figures do not fit. */
export default function PersonCard({ row, onOpen }) {
  return (
    <Box component="li" sx={{ borderBottom: `1px solid ${WD.border}` }}>
      <ButtonBase onClick={() => onOpen(row.person.id)} sx={{ display: 'block', width: '100%', textAlign: 'left', px: 2, py: 1.75 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <PersonAvatar person={row.person} size={34} />
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography noWrap sx={{ fontSize: 13.5, fontWeight: 600, color: WD.ink }}>{row.person.name}</Typography>
            <Typography noWrap sx={{ fontSize: 12, color: WD.inkFaint }}>{row.person.title || '-'}</Typography>
          </Box>
          <LoadTag level={row.level} small />
        </Box>
        <Box display="flex" alignItems="center" gap={1.5} sx={{ mt: 1.5 }}>
          <LoadBar pct={row.pct} level={row.level} />
          <LoadPercent row={row} />
        </Box>
        <Typography sx={{ mt: 1, fontSize: 12, color: WD.inkMuted, ...FIGURE }}>
          {fmtHours(row.allocated)} / {fmtHours(row.capacity)} · {row.tasks} tasks · logged {fmtHours(row.logged)}
          {row.needsHours > 0 && <Box component="span" sx={{ color: LEVEL_TONE.atCapacity.text }}> · {row.needsHours} need hours</Box>}
        </Typography>
      </ButtonBase>
    </Box>
  );
}
